import React from 'react'
import { Typography, CircularProgress, Grid, withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

const styles = theme => ({
	root: {
		height: '100vh',
	},
	progress: {
		margin: theme.spacing.unit,
	}
})

const AppLoading = (props) => (
	<Grid container justify="center" className={props.classes.root} alignItems="center" alignContent="center">
		<CircularProgress size={50} className={props.classes.progress} />
		<Typography variant="h5" >Loading...</Typography>
	</Grid>
)

AppLoading.propTypes = {
	classes: PropTypes.object
}

export default withStyles(styles)(AppLoading)


// WEBPACK FOOTER //
// ./src/components/AppLoading.js